/**
 * Genera el enlace de WhatsApp con mensaje predefinido
 * @param {Object} product - Objeto del producto
 * @returns {string} URL de WhatsApp
 */
export const generateWhatsAppLink = (product) => {
  const phoneNumber = process.env.REACT_APP_WHATSAPP_NUMBER || 'sin numero';
  const baseMessage = process.env.REACT_APP_WHATSAPP_MESSAGE || 'Hola! Estoy interesado en el producto: ';
  
  const message = `${baseMessage}*${product.descripcion}*\nPrecio: $${product.precio}\n\n¿Podrían darme más información?`;
  
  const encodedMessage = encodeURIComponent(message);
  
  // Formato de WhatsApp Web/API
  return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
};

/**
 * Abre WhatsApp con el mensaje predefinido
 * @param {Object} product - Objeto del producto
 */
export const openWhatsApp = (product) => {
  const link = generateWhatsAppLink(product);
  window.open(link, '_blank');
};

